import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type PropsWithChildren, useState, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MyAccountDialogContext } from './useContextMyAccountDialog'

export interface MyAccountDialogProviderProps {
  title?: ReactNode
  message?: ReactNode
}

export function MyAccountDialogProvider({ children }: PropsWithChildren) {
  const { t } = useTranslation()
  const [dialogPayload, setDialogPayload] = useState<MyAccountDialogProviderProps>()
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false)

  const showDialog = (props: MyAccountDialogProviderProps) => {
    setIsOpenDialog(true)
    setDialogPayload(props)
  }

  const showDialogServerError = () => {
    setIsOpenDialog(true)
    setDialogPayload({
      title: t('login.serverErrorDialogContent'),
    })
  }

  const closeDialog = () => setIsOpenDialog(false)
  const openDialog = () => setIsOpenDialog(true)
  return (
    <MyAccountDialogContext.Provider value={{ dialogPayload, showDialog, openDialog, closeDialog, showDialogServerError }}>
      {children}
      <Dialog
        disablePortal
        onClose={closeDialog}
        open={isOpenDialog}
        fullWidth
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '320px',
            },
          },
        }}
      >
        <DialogTitle sx={{ m: 0, pt: 2, pb: dialogPayload?.message ? 2 : 1 }}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Text align="center" variant="h4" color={colors.grey900}>{dialogPayload?.title}</Text>
          </Box>
        </DialogTitle>
        {dialogPayload?.message && (
          <DialogContent sx={{ p: '8px 16px' }}>
            <Text align="center" variant="body">{dialogPayload?.message}</Text>
          </DialogContent>
        )}
        <DialogActions>
          <Button fullWidth onClick={closeDialog}>
            {t('button.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </MyAccountDialogContext.Provider>
  )
}
